/**
 系统管理--状态码管理
 */
import React, { PureComponent } from "react";
import FormCore from "@/components/display/form/formCore";
import ScGridTable from "@/components/display/table/gridTableCore";
import PropTypes from "prop-types";
import fetchHandler from "@/fetch/fetchHandler";
import moment from "moment";
import { Modal, message } from "antd";
import {
  getStatusCodeList,
  stubFaultReportedlevelData,
  updateStatusCodeInfo,
  getCodeNameList,
  getDicCodeList
} from "@/fetch/fetchApi";
import RefreshGrid from "@/utils/refreshGrid";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { useAuth } from "@/utils/utils";

// eslint-disable-next-line arrow-parens
@connect((state) => state)
class ErrorCodeManage extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.faultReportingList;
    this.state = {
      levelOption: [],
      autoOption: [
        { text: "全部", value: "" },
        { text: "是", value: "1" },
        { text: "否", value: "2" },
      ],
      errorOption: [
        { text: "全部", value: "" },
        { text: "是", value: "1" },
        { text: "否", value: "0" },
      ],
      errorTypeOption: [
        { text: "全部", value: "" },
        { text: "是", value: "1" },
        { text: "否", value: "2" },
      ],
      tiggerIdTypeOption: [
        // { text: "全部", value: "" },
        // { text: "充电桩", value: "0" },
        // { text: "平台", value: "1" },
        // { text: "地锁", value: "11" },
        // { text: "智能运维", value: "智能运维" },
      ],
      formConfig: null,
      typeOption: [
        {
          text: this.props.intl.messages.faultReportingList.operationMode1, // '全部',
          value: "",
        },
      ],
      adviceContent: null,
      adviceVisible: false,
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.getLevel();
    this.getTiggerIdTypeType();
    this.setState({
      formConfig: this.initFormConfig(),
    });
    this.init();
  }

  componentDidMount() {
    const param = {
      date: `${moment(new Date()).subtract(0, "d").format("YYYY-MM-DD")},${moment(new Date())
        .subtract(0, "d")
        .format("YYYY-MM-DD")}`,
    };

    this.fetchApi(param);
  }


  //获取触发方
  getTiggerIdTypeType() {
    fetchHandler(getDicCodeList, {
      code: "maint.statustigger",
    }).then((res) => {
      if (res.data && res.code === "success") {
        this.setState({
          tiggerIdTypeOption: res.data.map(item=>{
            return {
              text: item.name,
              value: item.code,
            }
          }),
        }, () => {
          this.setState({
            formConfig: this.initFormConfig(),
          });
        },);
      }
    });
  }

  // 获取故障等级
  getLevel() {
    fetchHandler(stubFaultReportedlevelData, {
      type: "1",
    }).then((res) => {
      const list = res.data.map((item) => {
        const foo = {
          text: item.name,
          value: item.id,
        };
        return foo;
      });
      const first = {
        text: this.internationalization.operationMode1, // '全部',
        value: "",
      };
      list.unshift(first);
      this.setState(
        {
          levelOption: [...list],
        },
        () => {
          this.setState({
            formConfig: this.initFormConfig(),
          });
        },
      );
      this.init();
    });
  }

  init() {
    this.setState({
      tableConfig: {
        tableKey: "errorCodeManageTable",
        tableColumns: [
          {
            name: "状态码", // '状态码',
            key: "code",
            colType: "textCol",
            align: "left",
          },
          {
            name: "故障名称", // '故障名称',
            key: "codeName",
            colType: "tipCol",
            align: "left",
          },
          {
            name: "触发方", // '触发方',
            key: "tiggerName",
            colType: "textCol",
            align: "left",
          },
          {
            name: "是否上报", // '是否上报',
            key: "isAlert",
            colType: "textCol",
            align: "left",
            render: (text) => {
              if (text === 1) {
                return "是";
              }
              return "否";
            },
          },
          {
            name: "是否为告警项", // '是否为告警项',
            key: "errorType",
            colType: "textCol",
            align: "left",
            render: (text) => {
              if (text === 1) {
                return "是";
              }
              return "否";
            },
          },
          {
            name: "告警处理超时", // '告警处理超时',
            key: "errorExcTime",
            colType: "textCol",
            align: "left",
            render: (text) => {
              if (text === null) {
                return "--";
              } else {
                return text + "秒";
              }
            },
          },
          {
            name: this.internationalization.title10, // '运维等级',
            colType: "textCol",
            align: "left",
            render: (value, row) => {
              return (
                <div
                  style={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
                  {row.levelName && row.levelName !== "--" && (
                    <div className="tip-lv">
                      <span className="first" style={{ background: row.color }}></span>
                      <span className="last" style={{ background: row.color }}></span>
                    </div>
                  )}
                  <span>{row.levelName}</span>
                </div>
              );
            },
          },
          {
            name: "是否影响充电", // '是否影响充电',
            key: "isCharging",
            colType: "textCol",
            align: "left",
            render: (text) => {
              if (text === 1) {
                return "是";
              }
              return "否";
            },
          },
          {
            name: "停止原因分类", // '停止原因分类',
            key: "statusTypeName",
            colType: "textCol",
            align: "left",
          },
          {
            name: "异常停止", // '异常停止',
            key: "isErrorStop",
            colType: "textCol",
            align: "left",
            render: (text) => {
              if (text === 1) {
                return "是";
              }
              return "否";
            },
          },
          {
            name: "是否影响计费", // '是否影响计费',
            key: "isBilling",
            colType: "textCol",
            align: "left",
            render: (text) => {
              if (text === 1) {
                return "是";
              }
              return "否";
            },
          },
          {
            name: "是否影响状态", // '是否影响计费',
            key: "isEffectStubStatus",
            colType: "textCol",
            align: "left",
            render: (text) => {
              if (text === 1) {
                return "是";
              }
              return "否";
            },
          },

          {
            name: "是否自动派单", // '',
            colType: "textCol",
            align: "left",
            width: 50,
            render: (value, row) => {
              const autoTicket = row.autoTicket;
              switch (autoTicket) {
                case 1:
                  return "是";
                // break;
                case 2:
                  return "否";
                // break;

                default:
                  return <div>{row.eventRule}</div>;
                // break;
              }
            },
          },
          {
            name: "故障内容", // '故障内容',
            key: "desc",
            colType: "tipCol",
            align: "left",
          },
          {
            name: "运维建议", // '操作提示',
            key: "maintMsg",
            colType: "textCol",
            align: "left",
            render: (text) => {
              return text && text !== "--" ? (
                <a onClick={() => this.setState({ adviceContent: text, adviceVisible: true })}>
                  查看更多
                </a>
              ) : (
                "--"
              );
            },
          },
          {
            name: "操作", // 操作
            key: "action",
            colType: "action", // 操作列，可定义多种操作。
            actionMap: [
              useAuth("900402")
                ? {
                    type: "href",
                    actionName: "配置", // 默认actionName
                    // 根据grid数据 自定义显示actionName
                    handler: (res) => {
                      this.openTab(
                        { errorCodeInfo: res, levelOption: this.state.levelOption },
                        { key: "errorCodeConfig", titleText: "状态码配置" },
                      );
                    },
                  }
                : "",
              useAuth("900403") || useAuth("900404")
                ? {
                    type: "confirm",
                    actionName: "开启自动派单",
                    render: (record) => {
                      return record.autoTicket == 1 ? "关闭自动派单" : "开启自动派单";
                    },
                    handler: (record) => {
                      fetchHandler(updateStatusCodeInfo, {
                        code: record.code,
                        autoTicket: record.autoTicket == 1 ? 2 : 1,
                      }).then((res) => {
                        if (res && (res.code === "ok" || res.code === "success")) {
                          message.success("操作成功");
                          RefreshGrid(this.context.store, "errorCodeManageTable");
                        }
                      });
                    },
                  }
                : "",
            ],
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
        },
        dataApi: getStatusCodeList,
        autoRefresh: !1, // 设置为true 直接加载grid数据
      },
    });
  }

  initFormConfig = () => {
    const formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: "请输入状态码", 
          param: {
            name: "code",
            type: "string",
          },
          labelName: "状态码", 
          required: false,
        },
        {
          type: "autoWatch",
          placeholder: this.internationalization.placeholder1, 
          param: {
            name: "codeName",
            type: "string",
          },
          labelName: "故障名称", 
          required: !1,
          sourceApi: getCodeNameList,
        },
        {
          type: "select",
          options: this.state.levelOption,
          placeholder: this.internationalization.placeholder, 
          param: {
            name: "levelId",
            type: "string",
          },
          labelName: this.internationalization.title4, // '运维等级',
          required: !1,
        },
        {
          type: "select",
          options: this.state.autoOption,
          placeholder: this.internationalization.placeholder, 
          param: {
            name: "autoTicket",
            type: "string",
          },
          labelName: "自动派单", // '自动派单',
          required: !1,
        },
        {
          type: "select",
          options: this.state.errorOption,
          placeholder: this.internationalization.placeholder, 
          param: {
            name: "isAlert",
            type: "string",
          },
          labelName: "是否上报", // '是否上报',
          required: !1,
        },
        {
          type: "select",
          options: this.state.errorTypeOption,
          placeholder: this.internationalization.placeholder, 
          param: {
            name: "errorType",
            type: "string",
          },
          labelName: "是否为告警项", // '是否为告警项',
          required: !1,
        },
        {
          type: "select",
          options: this.state.tiggerIdTypeOption,
          placeholder: this.internationalization.placeholder, 
          param: {
            name: "tiggerId",
            type: "string",
          },
          labelName: "触发方", // '触发方',
          required: !1,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            useAuth("900401")
              ? {
                  btnType: "submit",
                  // icon: 'search',
                  text: this.internationalization.btn1, // '查询'
                }
              : "",
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      defaultParams: {},
      tableKey: "errorCodeManageTable",
      tablePage: "故障上报",
    };

    return formConfig;
  };

  fetchApi = (param) => {
    console.log('fetchApi:',param);
    // 当设置formTarget为grid时，执行自定义提交事件。
    if (this.state.formConfig.formTarget === "grid") {
      return;
    }
    // 请求fetch 对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(param);
    } else {
      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "errorCodeManageTable", param);
    }
  };

  openTab(param, e) {
    this.props.onAdd.bind(window.LayoutTab)(e, param);
  }

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel gzsbTable">
          <ScGridTable config={this.state.tableConfig} />
        </div>
        <Modal
          title="运维建议"
          visible={this.state.adviceVisible}
          footer={null}
          onCancel={() => this.setState({ adviceVisible: false })}>
          <div dangerouslySetInnerHTML={{ __html: this.state.adviceContent }}></div>
        </Modal>
      </div>
    );

    return Content;
  }
}

export default injectIntl(ErrorCodeManage);



// WEBPACK FOOTER //
// ./src/AntD/pages/system/errorCodeManage/index.js